module.exports = __webpack_public_path__ + "img/SMT_28_Ms_Ann_Ng_Tze_Wee.385114b9.jpg";